// Rates are stored as factors (0.15 = 15%); rounding to 5 places drops
// binary-float noise like 0.150000002 while keeping the precision a stored factor can carry.
const FRACTION_DECIMALS = 5;

export function formatFraction(fraction?: number): string {
  if (fraction == null) {
    return "";
  }
  return `${Number(fraction.toFixed(FRACTION_DECIMALS))}`;
}

// A native date input works in the browser's local timezone, so an instant must be
// rendered and compared on a local yyyy-mm-dd basis; an ISO/UTC slice can land on the
// adjacent day in negative-UTC offsets and make today's selection read as past.
function toLocalDateOnly(instant: string | number | Date): string {
  const date = new Date(instant);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// The expiry picker works on the operator's local clock, so render the stored instant on the
// same local basis ("what you pick is what you see"); a UTC slice would shift the displayed
// time away from the picked value. A null instant means the override never expires.
export function formatExpiry(expiresAtMillis: number | undefined, permanentLabel: string): string {
  if (expiresAtMillis == null) {
    return permanentLabel;
  }
  const date = new Date(expiresAtMillis);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${toLocalDateOnly(date)} ${hours}:${minutes}`;
}
